import { render } from "./ERezept.vue?vue&type=template&id=928e7300"
import script from "./ERezept.vue?vue&type=script&lang=js"
export * from "./ERezept.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__